// The MapMarkerFactory is associated with one map at a time.
window.MapMarkerFactory = function() { // executed immediately
  
  function extract_marker_options(json) {
    var defaults = {map: app.g_map, raiseOnDrag: !json.kind};
    defaults.position = json.latlng || new google.maps.LatLng(json.latitude, json.longitude);
    if ( json.kind == 'boulder' ) defaults.icon = MapMarkerIcons.boulder();
    if ( json.kind == 'sector'  ) defaults.icon = MapMarkerIcons.sport();
    if ( json.kind == 'dws'  ) defaults.icon = MapMarkerIcons.dws();
    if ( json.kind == 'trad_n_p'  ) defaults.icon = MapMarkerIcons.trad();
    if ( json.kind == 'parking_space' ) defaults.icon = MapMarkerIcons.parking_space();
    return defaults;
  }
  
  function new_single_point_marker(json, tooltip) {
    try {
      var marker = SinglePointMarker(extract_marker_options(json));
      // now the map is passed in the json // marker.g_marker.setMap(app.g_map);
      marker.tooltip = tooltip || MapTooltip(json.url);
      marker.tooltip.bind(marker.g_marker);
      return marker;
    } catch(error) {
      console.log(error);
      return null;
    }
  }
  
  function new_symbol(json, markers) {
    markers = new MarkerCollection(markers);
    var symbol = new MapSymbol(json, markers);
    symbol.markers.set_observer(MapPointObserver(symbol));
    return symbol;
  }
  
  // public class methods
  return {
    new_crag: function(json) {
      return new_single_point_marker(json);
    },
    
    new_marker: function(json) {
      var map_point = new_single_point_marker(json);
      if ( map_point ) {
        return new_symbol(json, [map_point]);
      } else {
        return null;
      }
    }
  };
}();
